// extracted by mini-css-extract-plugin
module.exports = {"singleImage__image":"single-image-module--single-image__image--2Zm7F"};